import { render, staticRenderFns } from "./EpgProgramContainer.vue?vue&type=template&id=3f624f22&scoped=true&"
import script from "./EpgProgramContainer.vue?vue&type=script&lang=js&"
export * from "./EpgProgramContainer.vue?vue&type=script&lang=js&"
import style0 from "./EpgProgramContainer.vue?vue&type=style&index=0&id=3f624f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f624f22",
  null
  
)

export default component.exports